/** imports */
import * as React from 'react';
import { createRoot } from 'react-dom/client'
// our components
import { Main } from './main'
// import { SnackbarProviderComponent } from '../../../components/snackbarProviderComponent'

/** DOMへのrender */
// <div id='projectIndex'/> のコンポーネントが必要なことに注意
const rootElement = document.getElementById('projectIndex');

if (rootElement) {
  const root = createRoot(rootElement)
  root.render(
    // <SnackbarProviderComponent>
      <Main />
    // </SnackbarProviderComponent>
  )
} else {
  console.warn('トップページのコンテンツ表示用の要素が存在しません')
}